<div class="d-flex justify-content-between align-items-center">
  @if (item.type === 'DERIVAT') {
    <ng-container *ngTemplateOutlet="derivative" />
  } @else {
    <ng-container *ngTemplateOutlet="default" />
  }
</div>
<hr class="less-margin" />

<ng-template #default>
  <div class="truncate" [title]="item.name">
    <web-components-instrument-details-link class="font-medium" [isin]="item.isin">
      {{ item.name }}
    </web-components-instrument-details-link>
  </div>
  <div class="d-flex justify-content-end align-items-center">
    <div>{{ item?.quote?.value | currency: 'EUR' : 'symbol' : (item?.quote?.value < 50 ? '1.3' : '1.2') }}</div>
    <div
      [title]="'my-home.my-top-instruments.performance-title' | transloco"
      [ngClass]="item.perf >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }"
      class="quoteindicator-variant3 ml-2"
      style="width: 70px; text-align: right"
      zeroBlink
      [val]="item?.quote?.b"
    >
      {{ item.perf >= 0 ? '+' : '' }}{{ item.perf | number: '1.2-2' }}&nbsp;%
    </div>
    <ng-container *ngTemplateOutlet="buyBtn" />
  </div>
</ng-template>

<ng-template #derivative>
  <web-components-instrument-details-link class="flex-grow-1" [isin]="item.isin">
    <div class="d-flex justify-content-between align-items-center gap-half">
      <div class="d-flex align-items-center gap-half">
        <div class="option-type d-flex justify-content-between align-items-center">
          <span class="zero-text p-base-med">{{ item.optionType }}</span>
          <web-design-system-icon class="icon" name="arrow-1" size="small" />
        </div>
        <span class="zero-text p-base-reg text-nowrap truncate">{{ item.underlying }}</span>
      </div>
      <div class="zero-text p-base-med">{{ item.wkn }}</div>
    </div>
  </web-components-instrument-details-link>
  <div class="d-flex justify-content-end">
    <ng-container *ngTemplateOutlet="buyBtn" />
  </div>
</ng-template>

<ng-template #buyBtn>
  <a
    class="trade buy small cursor-pointer ml-3"
    [routerLink]="commonRoutes.postlogin.buyAndSell"
    [queryParams]="{
      isin: item.isin,
      direction: 'buy',
      fzsrc: 'zerocockpit',
      fzmedium: 'web',
      fzcampaign: 'topkachel-home-' + item.type,
      fzterm: item.isin,
      fzcontent: 'position' + (index + 1),
    }"
  >
    K
  </a>
</ng-template>
